// Separately defined tags to prevent circular dependencies

export const fundingSourcesTags = {
  allFundingSources: 'allFundingSources',
  lenderAssociations: 'lenderAssociations',
  servicerAssociations: 'servicerAssociations',
};

export const programTags = {
  allPrograms: 'allPrograms',
  programBundle: 'programBundle',
  lenderAssociations: 'lenderAssociations',
  programsEligibleToAssociate: 'programsEligibleToAssociate',
  allProgramFeeTemplates: 'allProgramFeeTemplates',
  publishedFeeTemplates: 'publishedFeeTemplates',
};

export const lenderTags = {
  allLenders: 'allLenders',
  lender: 'lender',
  lenderUsers: 'lenderUsers',
  lenderPermissionGroups: 'lenderPermissionGroups',
  allLenderLocations: 'allLenderLocations',
  lenderUser: 'lenderUser',
  lenderPaymentInfo: 'lenderPaymentInfo',
};
